import React, { FocusEventHandler, useState } from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { FormikTouched } from 'formik/dist/types';

type Props = {
    label: string;
    name: string;
    data?: any[];
    size?: 'small' | 'medium' | undefined;
    margin?: 'dense' | 'normal' | 'none';
    required?: false | boolean;
    value?: any;
    touched?: boolean | FormikTouched<any> | FormikTouched<any>[] | undefined;
    errors?: any;
    disabled?: false | boolean;
    onChangeValue: (event: string[]) => void;
    reasonEnabled?: false | boolean;
    onReason?: any;
    getOptionLabel?: (option: any) => string;
    onBlur?: FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>;
};

const MultipleAutocompleteField = ({
    label,
    name,
    data,
    size,
    margin,
    required,
    value,
    touched,
    errors,
    disabled,
    onChangeValue,
    reasonEnabled,
    onReason,
    getOptionLabel,
    onBlur,
}: Props) => {
    //onChangeValue Formik
    //The variable MultipleAtocompleteFormik must be equal to the variable name of the formik
    //onChangeValue={(value) => formik.setFieldValue('MultipleAtocompleteFormik', value)}

    const [valuesItem, setValuesItems] = useState<any[]>(value);

    return (
        <Autocomplete
            multiple={true}
            id="tags-outlined"
            options={data || []}
            disabled={disabled}
            value={valuesItem}
            onChange={(_: any, newValue: any | null) => {
                let data: string[] = [];
                for (let i = 0; i < newValue.length; i++) {
                    data = data.concat(newValue[i].id);
                }
                setValuesItems(newValue || []);
                onChangeValue(data);
            }}
            onInputChange={(_: any, e: string | null, reason) => {
                if (reasonEnabled) {
                    onReason(reason);
                }
                if (reason === 'clear') {
                    onChangeValue([]);
                }
            }}
            getOptionLabel={
                !getOptionLabel ? (option) => option.name || '' : getOptionLabel
            }
            isOptionEqualToValue={(option, value) => option.id === value.id}
            filterSelectedOptions
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={label}
                    name={name}
                    size={size}
                    margin={margin}
                    required={required}
                    onBlur={onBlur}
                    helperText={touched ? errors : ''}
                    error={touched && Boolean(errors)}
                />
            )}
        />
    );
};

export default MultipleAutocompleteField;
